export interface FramePacket {
  buffer: ArrayBuffer;
  timestamp: number;
}

/**
 * 解析 .bin 文件（4 字节小端序长度前缀格式）为帧数据包列表。
 * 每帧是一个原始 LocalViewDTO protobuf buffer，可直接 feedData 给 ThreeMonitor。
 *
 * @param buf  原始二进制内容
 * @param decodeTimestamp  可选，从单帧 buffer 中解码时间戳的回调。
 *                         不传则 timestamp 全为 0（mock 回放时不需要时间戳）。
 */
export function parseBinBuffer(
  buf: ArrayBuffer,
  decodeTimestamp?: (frameBuf: ArrayBuffer) => number
): FramePacket[] {
  const dv = new DataView(buf);
  const packets: FramePacket[] = [];
  let offset = 0;

  while (offset + 4 <= buf.byteLength) {
    const length = dv.getUint32(offset, true);
    offset += 4;
    if (length === 0 || length > 10 * 1024 * 1024) break;
    if (offset + length > buf.byteLength) break;

    const packet = buf.slice(offset, offset + length);
    offset += length;

    let timestamp = 0;
    if (decodeTimestamp) {
      try {
        timestamp = decodeTimestamp(packet);
      } catch (_) {}
    }

    packets.push({ buffer: packet, timestamp });
  }

  return packets;
}
